export type MapHintMode = 'idle' | 'draw' | 'edit';

export interface MapHintContext {
  loadText: (key: string) => Promise<unknown>;
  hasPolygons: () => boolean;
  isDestroyed: () => boolean;
  changed: () => void;
}

const HINTS: Record<'draw' | 'edit' | 'list' | 'empty', { key: string; fallback: string }> = {
  draw: {
    key: 'Click_to_add_points_Double_click_to_finish_Esc_to_cancel_tr',
    fallback: 'Click to add points • Double-click to finish • Esc to cancel',
  },
  edit: {
    key: 'Click_a_vertex_midpoint_to_edit_Drag_vertices_Delete_to_remove_vertices_Esc_to_finish_tr',
    fallback: 'Click a vertex/midpoint to edit • Drag vertices • Delete to remove vertices • Esc to finish',
  },
  list: {
    key: 'Click_a_polygon_in_the_list_to_edit_Click_Save_when_done_tr',
    fallback: 'Click a polygon in the list to edit • Click Save when done',
  },
  empty: { key: 'Click_Draw_to_start_tr', fallback: 'Click Draw to start!' },
};

export class MapHintController {
  text: string | null = null;
  private key: string | null = null;

  constructor(private readonly context: MapHintContext) {}

  set(mode: MapHintMode): void {
    if (mode === 'draw' || mode === 'edit') this.show(HINTS[mode].key, HINTS[mode].fallback);
    else if (this.context.hasPolygons()) this.show(HINTS.list.key, HINTS.list.fallback);
    else this.show(HINTS.empty.key, HINTS.empty.fallback);
    this.context.changed();
  }

  show(key: string, fallback: string): void {
    this.key = key;
    this.text = fallback;
    this.context
      .loadText(key)
      .then((msg) => this.applyTranslation(key, typeof msg === 'string' && msg.length ? msg : fallback))
      .catch(() => this.applyTranslation(key, fallback));
  }

  private applyTranslation(key: string, text: string): void {
    if (this.context.isDestroyed() || this.key !== key) return;
    this.text = text;
    this.context.changed();
  }
}
